export const ALL_BUDGETS_VALUE = 'ALL_BUDGETS';
